import React from "react";
import "./TermsText.css";
import { useTranslation } from "react-i18next";

const TermsText = () => {
  const { t } = useTranslation();

  return (
    <p className="terms-text">
      {t("app.legal.terms")}{" "}
      <a href="https://about.aspose.app/legal/tos/" className="terms-link">
        {t("app.legal.termsOfService")}
      </a>{" "}
      {t("app.legal.and")}{" "}
      <a
        href="https://about.aspose.app/legal/privacy-policy/"
        className="terms-link"
      >
        {t("app.legal.privacyPolicy")}
      </a>
      .
    </p>
  );
};

export default TermsText;
